export default class Attributes {
    public static readonly LOGIN = 'login';
    public static readonly PASSWORD = 'password';
    public static readonly APPLE_STORE_LINK = 'https://apps.apple.com/app/amazon-a-to-z/id1413909063?mt=8';
    public static readonly GOOGLE_STORE_LINK = 'https://play.google.com/store/apps/details?id=com.amazon.atozm';
    public static readonly ATOZ_REDIRECT_DEV = 'https://atoz.amazon.work/';
    public static readonly API_URL_DEV = 'http://localhost:3100/idp/api';
    public static readonly RESET_TOKEN_REG_EXP = new RegExp(/^\w+$/);
}